const STROKE = 'fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"';

export const JONGLEUR_MARK =
  '<g transform="rotate(32 12 12)">' +
  `<path d="M12 2.5c2.6 0 4.3 2.6 4.3 6 0 2.6-1.3 4.4-2.6 5.6v5.6h-3.4v-5.6C9 12.9 7.7 11.1 7.7 8.5c0-3.4 1.7-6 4.3-6z" ${STROKE}/>` +
  '<path d="M8.6 10.6h6.8" stroke="currentColor" stroke-width="1.6"/>' +
  '<circle cx="12" cy="21.4" r="1.7" fill="currentColor"/></g>';

const SMALL_CLUB =
  '<ellipse cx="12" cy="7.5" rx="2.7" ry="4.2" fill="currentColor"/>' +
  '<path d="M12 11v7.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
  '<circle cx="12" cy="19.2" r="1.3" fill="currentColor"/>';

export const CASCADE_ICON = [-40, 0, 40]
  .map((turn) => `<g transform="rotate(${String(turn)} 12 21)">${SMALL_CLUB}</g>`)
  .join('');
